if (!customElements.get('moving-module')) {
    class MovingSwiper extends HTMLElement {
        mySwiper;
        constructor() {
            super();
            this.swipermodule = this.querySelector('.announce_featured_module');
            this.speed = parseInt(this.swipermodule.getAttribute("data-speed"));
        }
        connectedCallback() {

            this.mySwiper = new Swiper(this.swipermodule , {
      spaceBetween: 5,
      slidesPerView: 'auto',
      speed: this.speed,
      autoplay: {
        delay: 0,
        stopOnLastSlide: false,
        disableOnInteraction: false,
        pauseOnMouseEnter: false,
       },
       allowTouchMove:false,
      loop: true,
      observer: true,
      observeParents: false,
 
        });
            this.initEvent(this.mySwiper);
        }

        /**
         * 轮播图切换事件
         */
        handleSlideChange(swiper) {

        }

        initEvent(swiper) {

        }

    }
    customElements.define('moving-module', MovingSwiper);
}
